var __webpack_exports__ = {};
/*!***********************************!*\
  !*** ./src/js/cart-promo-aiod.js ***!
  \***********************************/
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
// Custom functions for All Automatic Discount module
document.addEventListener("DOMContentLoaded", function (event) {
  window.addEventListener("pageshow", function (evt) {
    if (evt.persisted) {
      setTimeout(function () {
        window.location.reload();
      }, 10);
    }
  }, false);
  window.strom = {
    lang: document.documentElement.lang,
    applyBtn: document.querySelector("#apply-discount-btn"),
    discountCodeError: document.querySelector("#discount-code-error"),
    discountCodeSuccess: document.querySelector("#discount-code-success"),
    discountCodeWrapper: document.querySelector("#applied-discount-code .applied-discount-code-wrapper"),
    discountCodeValue: document.querySelector("#applied-discount-code .applied-discount-code-value"),
    discountCodeInput: document.querySelector("#discount-code-input"),
    cartFooter: document.getElementById("main-cart-footer"),
    promoCode: document.getElementById("Summary-promo-code")
  };
  strom.cartFooter.addEventListener("click", function (e) {
    var remove = e.target.closest(".summary-discount-remove");
    if (remove) {
      var code = remove.closest("LI").getAttribute("data-discount-code");
      var codeList = window.csapps.csapp_discount_code.split(",").filter(function (el) {
        return el != code;
      });
      window.csapps.csapp_discount_code = codeList.join(",");
      window.fire_cart_data(1, "all", 0, null);
    }
  });
  strom.applyBtn.addEventListener("click", function (e) {
    e.preventDefault();
    strom.discountCodeError.style.display = "none";
    strom.discountCodeSuccess.style.display = "none";
    var code = strom.discountCodeInput.value.trim();
    if (code.length > 0) {
      var codeList = window.csapps.csapp_discount_code.length > 0 ? window.csapps.csapp_discount_code.split(",") : [];
      window.strom.codeList = codeList;
      codeList.push(code);
      var codeListLast = codeList.splice(-1);
      window.csapps.csapp_discount_code = codeListLast.join(",");
      window.cs_discount_code_verify = codeListLast.length;
      window.fire_cart_data(1, "all", 0, null);
    }
  });
  window.strom.fixPrice = function (price) {
    return strom.formatPrice(parseFloat((price / 100).toFixed(2)));
  };
  window.strom.formatPrice = function (price) {
    return strom.lang == "fr" ? price + "$" : "$" + price;
  };
  window.strom.formatTitle = function (title) {
    if (title.includes("---")) {
      var index = strom.lang == "fr" ? 0 : 1;
      return title.split("---")[index];
    }
    return title;
  };

  //  Build subtotal discounts
  window.strom.buildDiscount = function () {
    var discountWrapper = document.getElementById("subtotal-discounts");
    var list = discountWrapper.querySelector("UL");
    list.innerHTML = "";
    var template = document.getElementById("template-discount");
    if (window.csapps.discounts) {
      var discounts = window.csapps.discounts.cart_level_discount_applications;
      discounts.forEach(function (code) {
        var clone = template.content.cloneNode(true);
        var rawPrice = Number(code.value);
        var formattedPrice = rawPrice % 1 === 0 
          ? strom.formatPrice(rawPrice.toFixed(0)) 
          : strom.formatPrice(rawPrice.toFixed(2));
        var price = `<span class="discount-amount">-${formattedPrice}</span>`;
        clone.querySelector(".discount-name").innerHTML = strom.formatTitle(code.title) + price;
        if (code.is_discount_code) {
          clone.querySelector("LI").setAttribute("data-discount-code", code.title);
        } else {
          clone.querySelector(".summary-discount-remove").remove();
        }
        list.appendChild(clone);
      });
      var items = list.querySelectorAll("LI");
      discountWrapper.style.display = items.length > 0 ? "" : "none";
      var subtotal = document.getElementById("cart-subtotal-value");
      if (subtotal) {
        subtotal.textContent = strom.fixPrice(window.csapps.discounts.total_price);
      }
    }
  };

  // Build line-item discount
  window.strom.buildLineDiscount = function () {
    var discountPriceClass = "cart-item__discounted-prices";
    var regularPriceClass = "product-option";
    var discounts = window.csapps.discounts;
    if (discounts) {
      var discountTemplate = document.getElementById("template-item-discount");
      var discountTotalTemplate = document.getElementById("template-discounted-total");
      var regularTotalTemplate = document.getElementById("template-regular-total");
      var linePriceTemplate = document.getElementById("template-discounted-line");
      var table = document.querySelectorAll(".cart-item");
      var _loop = function _loop() {
        var item = discounts.items[key];
        var row = table[key];
        var list = row.querySelectorAll(".cart-item-discounts");
        row.querySelector(".price").textContent = strom.fixPrice(item.discounted_price);
        list.forEach(function (l) {
          l.innerHTML = "";
        });

        // Update discount label
        item.line_level_discount_allocations.forEach(function (discount) {
          list.forEach(function (l) {
            var clone = discountTemplate.content.cloneNode(true);
            var titleEl = clone.querySelector(".item-discout-title");

            // Format title
            var title = strom.formatTitle(discount.discount_application.title);
            
            // Only show price if it's not a gift card (only display price when there is no tax equivalency)
            var price = !item.gift_card 
              ? "<span class='item-discount-amount'>" + strom.formatPrice(discount.amount) + "</span>" 
              : "";

            titleEl.innerHTML = "- " + title + " " + price;
            l.appendChild(clone);
          });
        });

        // Update line item price
        var linePriceWrapper = row.querySelectorAll(".cart-item__line-price");
        var equivalence = parseFloat(row.getAttribute("data-equivalence-rate")) || 1;
        var final = Math.round(item.final_price / equivalence);
        var original = Math.round(item.original_price / equivalence);
        linePriceWrapper.forEach(function (lp) {
          lp.innerHTML = "";
          if (item.final_price < item.original_price) {
            var lineClone = linePriceTemplate.content.cloneNode(true);
            lineClone.querySelector(".cart-item__final-price").innerHTML = strom.fixPrice(final);
            lineClone.querySelector(".cart-item__old-price").innerHTML = strom.fixPrice(original);
            lp.appendChild(lineClone);
          } else {
            lp.textContent = strom.fixPrice(final);
          }
        });

        // Update Equivalence line
        var equivalenceLines = row.querySelectorAll(".tax-equivalence__amount");
        equivalenceLines.forEach(function (el) {
          el.textContent = strom.fixPrice(item.final_price - final);
        });

        // Update line total price
        var priceWrapper = row.querySelectorAll(".cart-item__price-wrapper");
        priceWrapper.forEach(function (p) {
          p.innerHTML = "";
          if (item.final_line_price < item.original_line_price) {
            var discountClone = discountTotalTemplate.content.cloneNode(true);
            discountClone.querySelector(".cart-item__old-price").textContent = strom.fixPrice(item.original_line_price);
            discountClone.querySelector(".cart-item__price").textContent = strom.fixPrice(item.final_line_price);
            p.appendChild(discountClone);
          } else {
            var regularClone = regularTotalTemplate.content.cloneNode(true);
            regularClone.querySelector(".price").textContent = strom.fixPrice(item.final_line_price);
            p.appendChild(regularClone);
          }
        });
      };
      for (var key in discounts.items) {
        _loop();
      }
    }
  };
  window.strom.translateContent = function (node) {
    var html = /<\/?[a-z][\s\S]*>/i;
    var handle = /{{?[a-z]*}}/;
    var index = strom.lang === "fr" ? 0 : 1;
    var textNode,
      walk = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null, false);
    while (textNode = walk.nextNode()) {
      var parent = textNode.parentElement;
      var span = parent.innerHTML.match(html);
      if (/---/.test(textNode.nodeValue)) {
        if (span && handle.test(parent.innerHTML)) {
          parent.innerHTML = parent.innerHTML.replace(handle, span[0]).split("---")[index];
        } else {
          textNode.nodeValue = textNode.wholeText.split("---")[index];
        }
      }
    }
  };

  // Remove loader after 8 sec in case something went wrong
  setTimeout(function () {
    var overlay = document.querySelector(".cart__ctas .loading-overlay");
    var cta = document.querySelector(".cart__checkout-button");
    if (overlay && cta) {
      overlay.classList.add("hidden");
      cta.disabled = false;
    }
  }, 8000);
});
window.cs_discount_code_verify = 0;

// translate text
var aiod_callback = function aiod_callback(mutationList, observer) {
  var _iterator = _createForOfIteratorHelper(mutationList),
    _step;
  try {
    var _loop2 = function _loop2() {
      var mutation = _step.value;
      var translate = true;
      mutation.addedNodes.forEach(function (node) {
        if (typeof strom === "undefined" || node.tagName === "SCRIPT" || node.tagName === "IFRAME") {
          translate = false;
        }
      });
      if (translate) {
        if (typeof strom != "undefined") {
          strom.translateContent(mutation.target);
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var aiod_observer = new MutationObserver(aiod_callback);
aiod_observer.observe(document.body, {
  childList: true,
  subtree: true
});
window.cs_discount_applied_Cart = function () {
  document.querySelector(".cart__ctas .loading-overlay").classList.add("hidden");
  if (window.cs_discount_code_verify > 0) {
    var applied_length = window.csapps.csapp_discount_code.length;
    if (window.csapps.csapp_discount_code.length == applied_length && window.cs_discount_code_verify && window.csapps.csapp_discount_code != "") {
      strom.discountCodeSuccess.style.display = "block";
      strom.discountCodeError.style.display = "none";
      strom.promoCode.click();
    } else {
      strom.discountCodeSuccess.style.display = "none";
      strom.discountCodeError.style.display = "block";
      if (window.strom.codeList) {
        window.csapps.csapp_discount_code = window.strom.codeList.join(",");
        window.cs_discount_code_verify = window.strom.codeList.length;
        window.fire_cart_data(1, "all", 0, null);
      }
    }
    window.cs_discount_code_verify = 0;
  }
  strom.buildLineDiscount();
  strom.buildDiscount();
};
